module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help-center-content"
  }, [_c('h4', [_vm._v("寻找任务")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("1.  海选任务是什么？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("海选任务是指作家或出版社以任务的形式公开招募主播。作家/出版社会在海选任务中说明录制内容、周期、佣金和分成比例等，您可以根据自己的喜好自由参加海选选拔。")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("2.  如何参加海选任务？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("在“我有好声音”页面，选择“去找海选任务”，进入海选任务页面。在主播工作台，也可以去找任务哦。"), _c('br'), _vm._v("\n        您可以根据个人情况挑选合适的海选任务。选定任务以后，根据海选任务提供的素材，任选一段进行演播，时长在5分钟左右。建议您挑选包含对话情节的内容进行演播，这样有利于展现您的声音表现力喔。在任务详情页，点击“参加海选”，录制并上传声音样本，就意味着成功参加海选。\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("3.  海选任务的任务状态都是什么意思呢？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("处于海选中的任务，主播可以自由参选。而处于选拔中和制作中的任务，就说明不能再参加选拔了。")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("4.  如何知道我有没有被选拔上呢？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("如果您参加的海选任务被选拔上，您会收到选拔成功的消息。在主播工作台，请注意查看您的消息。")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("5.  可以同时参加多个海选任务吗？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("可以。多参加试音能够提高中选几率。")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("6.  海选失败，对我有什么影响吗？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("没有。这次的失败是为了迎接下一次成功的到来。坚持尝试，您一定可以找到心仪的海选任务的。")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("7.  除了海选任务，还有什么方式可以接任务呢？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("您还可以通过编辑个人声音标签，选择自己擅长的作品类型并添加试音，我们将根据您所选择的类型为您推荐相应的版权作品播讲。")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("8.  声音标签是什么？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("声音标签是用来描述你个人声音优势的关键字词。您可以定义自己擅长播讲的作品类型。比如：浪漫言情等。")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("9.  如何添加声音标签？")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("在“主播工作台”中选择“声音标签”，开始添加声音标签。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b93face!./~/vue-loader/lib/selector.js?type=template&index=0!./views/anchor/helpCenter/SearchTask.vue
// module id = 355
// module chunks = 0